import { render, staticRenderFns } from "./DocumentsProductModel.vue?vue&type=template&id=63cf130e"
import script from "./DocumentsProductModel.vue?vue&type=script&lang=js"
export * from "./DocumentsProductModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports